<template>
    <b-container>
        <b-row align-h="center">
            <b-col lg="6" md="12">
                <b-card>
                    <b-form @submit="onSubmit">
                        <b-form-group label="İsim:" label-for="isim">
                            <b-form-input
                                    id="isim"
                                    v-model="form.isim"
                            />
                        </b-form-group>

                        <b-form-group
                                label="Eposta:"
                                label-for="eposta"
                        >
                            <b-form-input
                                    id="eposta"
                                    v-model="form.eposta"
                                    type="email"
                                    
                            />
                        </b-form-group>

                        <b-form-group
                                label="Kızılay Eposta:"
                                label-for="kizilayEposta"
                        >
                            <b-form-input
                                    id="kizilayeposta"
                                    v-model="form.kizilayEposta"
                                    type="email"
                            />
                        </b-form-group>


                        <b-form-group
                                label="Telefon:"
                                label-for="telefon"
                        >
                            <b-form-input
                                    id="telefon"
                                    v-model="form.telefon"
                            />
                        </b-form-group>


                        <b-form-group
                                label="Tc Kimlik Numarası:"
                                label-for="tcKimlik"
                        >
                            <b-form-input
                                    id="tcKimlik"
                                    v-model="form.tcKimlik"
                            />
                        </b-form-group>

                        <b-form-group
                                label="İl:"
                                label-for="il"
                        >
                            <b-form-input
                                    id="il"
                                    v-model="form.il"
                            />
                        </b-form-group>

                        <b-form-group
                                label="İlçe:"
                                label-for="ilce"
                        >
                            <b-form-input
                                    id="ilce"
                                    v-model="form.ilce"
                            />
                        </b-form-group>

                        <b-form-group
                                label="Açıklama:"
                                label-for="aciklama"
                        >
                            <b-form-input
                                    id="aciklama"
                                    v-model="form.aciklama"
                            />
                        </b-form-group>

                        <b-form-group>
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.bayanMi"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Bayan Mı
                            </b-form-checkbox>
                        </b-form-group>
                        <b-form-group label="Yetkiler">
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.yonetici"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Yönetici
                            </b-form-checkbox>
                            
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.mektupEditor"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Mektup Editör
                            </b-form-checkbox>
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.mektupOperator"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Mektup Operatör
                            </b-form-checkbox>


                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.kartEditor"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Kart Editör
                            </b-form-checkbox>
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.kartOperator"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Kart Operatör
                            </b-form-checkbox>
                            
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.iadeOperator"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                İade Operatör
                            </b-form-checkbox>
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.latinceImla"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Latince İmla
                            </b-form-checkbox>
                            <b-form-checkbox switch
                                             size="md"
                                             v-model="form.aktif"
                                             :value="true"
                                             :unchecked-value="false"
                            >
                                Aktif
                            </b-form-checkbox>
                        </b-form-group>
                        <b-button type="submit" variant="primary">Kaydet</b-button>
                        <br style="margin: 30px"/>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {mapGetters} from "vuex";
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import {KisiGetir, KisiPost} from "@/api/kisi";

    export default {
        data() {
            return {
                form: {
                    eposta: '',
                    isim: '',
                    kizilayEposta: '',
                    telefon: '',
                    tcKimlik: '',
                    il: '',
                    ilce: '',
                    yonetici: false,
                    editor: false,
                    operator: false,
                    latinceImla: false,
                    iadeOperator: false,
                    bayanMi: false,
                    aktif: false,

                },
                isEditPage: false,
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
            }
        },

        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ])
        },
        created() {

        },
        async mounted() {
            const that = this;
            if (!this.girisYapmismi) {
                await new GoogleTokenIleGirisYapmayiDene(this);
            }

            if (!this.girisYapmismi) {
                this.gelen.mesaj = "Giriş yapmanız lazım";
                this.gelen.hataVarMi = true;

                setTimeout(function () {
                    that.$router.push("/giris-yap?url=" + encodeURI("/mektup"))
                }, 3000);
                return
            }
            this.gelen = await KisiGetir(this.$route.params.id);

            if (this.$route.params && this.$route.params.id > 0) {
                this.isEditPage = true;
                this.form = this.gelen.data
            } else {
                console.log('edit sayfası değil')
            }
        },
        methods: {
            async onSubmit(evt) {
                evt.preventDefault();
                let result;
                if (this.isEditPage)
                    result = await KisiPost(this.form, this.form.kisiId);
                else
                    result = await KisiPost(this.form, -1);
                if (result.hataVarMi)
                    this.$notify({
                        group: 'ust',
                        title: 'Töbe Estağfirullah',
                        text: result.mesaj,
                        type: 'danger'
                    });
                else
                    this.$notify({
                        group: 'ust',
                        title: 'Elhamdülillah',
                        text: 'Kayıt Başarılı',
                        type: 'success'
                    });
                await this.$router.push('/kisiler')
            }
        }
    }
</script>